<template>
    <div
        :class="{ 'invisible opacity-0': !userMadeSelection }"
        class="transition-opacity duration-300 ease-in-out"
    >
        <base-button
            @click="showResetModal"
            :is-disabled="isDisabled"
            class="h-auto lg:underline normal-case text-sm font-light tracking-normal"
        >
            {{ $t('RESET') }}
        </base-button>

        <base-modal-confirm
            @modalClose="showModal = false"
            @confirmAndExit="resetAndClose"
            :show-modal="showModal"
            :modal-heading="$t('RESET_CONFIRM')"
            :modal-copy="$t('RESET_CONFIRM_COPY')"
            :cta-copy="$t('RESET')"
        />
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import BaseButton from './BaseButton.vue';
    import BaseModalConfirm from './BaseModalConfirm.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseButton,
            BaseModalConfirm,
        },

        data() {
            return {
                isDisabled: false,
                showModal: false,
            };
        },

        computed: {
            userMadeSelection() {
                return this.customizerStore.userMadeSelection;
            },
        },

        methods: {
            showResetModal() {
                this.showModal = true;
            },

            resetAndClose() {
                this.customizerStore.resetCustomization();
                this.appStore.resetCustomization();

                this.showModal = false;
            },
        },
    };
</script>
